export const ButaWarnaSurat = () => ['Ya', 'Tidak', 'Tidak diketahui', 'Tidak diperiksa']